export default __webpack_public_path__ + "static/media/step3.c60296bc.png";